import React from "react";
import { observer } from "mobx-react";
import { ScorePerPeriod } from "@gp/models";

export const PeriodScores = observer(function PeriodScores({
	scoresPerPeriod,
}: {
	scoresPerPeriod: ScorePerPeriod[];
}) {
	return (
		<>
			{scoresPerPeriod.map((periodItem, idx) => {
				return (
					<div key={idx} className="event__stats__item">
						<div className="event__stats__label">P{periodItem.periodNumber}</div>
						<div className="event__stats__result">
							<span>{periodItem.home || 0}</span>
							<span> - </span>
							<span>{periodItem.away || 0}</span>
						</div>
					</div>
				);
			})}
		</>
	);
});
